import { LoadingState } from '@lcs/shared/api';
import { on } from '@ngrx/store';
import { createUserSuccess } from 'src/app/pages/add-user/state/add-user.actions';
import { saveUserDetailSuccess } from 'src/app/pages/user-details/state/user-detail.actions';
import { UserOption } from 'src/app/pages/user-register/models/user-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { filterNamedOption } from '../../select/shared/filter-named-option';
import { userOptionActions } from './user-option.actions';

export const userOptionFeatureKey = 'userOptions';

export type UserOptionState = EagerSelectState<UserOption>;

const adapter = createEagerSelectAdapter<UserOptionState, UserOption>({
   featureKey: userOptionFeatureKey,
   selectId: (user: UserOption) => {
      return user.userId;
   },
});

export const userOptionSelectors = adapter.getSelectors(filterNamedOption);

const initialState = adapter.getInitialState();

export const userOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   userOptionActions.search,
   userOptionActions.searchReset,
   userOptionActions.loadFromApi,
   userOptionActions.loadFromApiSuccess,
   userOptionActions.loadFromApiFailure,
   null,
   on(createUserSuccess, saveUserDetailSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Init,
      };
   })
);
